export const input = {
    slots: {
        base: 'placeholder:text-muted',
    },
    variants: {
        size: {
            md: {
                base: 'p-3.5',
            },
        },
    },
}
